export const performanceTableReport = {
	tabName: "Desempeño de las mesas",
	label: "Reportes de mesas",
	title: "Monitoree el desempeño de las mesas y potencie la gestión de su restaurante.",
	averageTime: "Tiempo promedio",
	tableNumber: "nº de mesa",
	qtdTimes: "cant. de veces",
	filters: {
		table: "Todas las mesas",
		periodOptions: {
			sevenDays: "7 días",
			fifteenDays: "15 días",
			thirtyDays: "30 días",
			sixtyDays: "60 días",
		},
		allTables: "Todas las mesas",
	},
	more: "más",
	less: "menos",
	eventPercentage: "A {{comparison}} que el último evento",
	companiePercentage: "A {{comparison}} que en los últimos {{days}} días",
	served: "Atendidos",
	cards: {
		totalBilling: "Facturación total",
		peopleServed: "Personas atendidas",
		averageTicketPerTable: "Ticket promedio por mesa",
		averageTicketPerPerson: "Ticket promedio por persona",
		bestPerformanceByWaiter: "Mejor desempeño por mesero",
		mostSoldProduct: "Producto más vendido",
		averageSpins: "Promedio de rotaciones",
		AverageLengthOfStay: "Tiempo promedio de permanencia",
		tableCombinations: "Combinaciones de mesas",
		nextPage: "Siguiente",
		previousPage: "Anterior",
		totalSales: "Total en ventas",
		averageTicket: "Ticket promedio",
		attendances: "Atenciones",
	},
	table: {
		title: "Consumo de mesas",
		columns: {
			tableName: "MESA",
			employeeName: "MESERO",
			numberOfSeats: "PERSONAS",
			openedAt: "APERTURA",
			permanence: "PERMANENCIA",
			tip: "SERVICIO",
			productsValue: "PRODUCTOS",
			closedAt: "CIERRE",
			discount: "DESCUENTOS",
			refundValue: "REEMBOLSOS",
			totalValue: "TOTAL",
			products: {
				imageUrl: "FOTO",
				sku: "SKU",
				name: "NOMBRE DEL PRODUCTO",
				quantity: "CANTIDAD",
				unitPrice: "VALOR UNITARIO",
				subTotal: "SUBTOTAL",
				discount: "DESCUENTOS",
				total: "VALOR TOTAL",
			},
		},
	},
};
